import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOT_PROGRAM } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

// 동적 임포트
const Program = lazy(() => import('@/pages/program'));
const ProgramList = lazy(() => import('@/pages/program/program/ProgramList'));
const ProgramDetail = lazy(() => import('@/pages/program/program/ProgramDetail'));
const SessionList = lazy(() => import('@/pages/program/session/SessionList'));
const SessionDetail = lazy(() => import('@/pages/program/session/SessionDetail'));

export const programRoutes: TypedRouteObject = {
	path: ROOT_PROGRAM,
	element: withSuspense(Program),
	handle: {
		title: '프로그램 관리',
		subTitle: '락앤런 정기 프로그램 관리 현황'
	},
	children: [
		{
			index: true,
			element: <Navigate to="list" replace />
		},
		// 프로그램 관리
		{
			path: paths.program.program.list,
			element: withSuspense(ProgramList),
			handle: {
				title: '락앤런 프로그램 관리',
				subTitle: '락앤런 정기 프로그램 관리'
			}
		},
		{
			path: paths.program.program.detail,
			element: withSuspense(ProgramDetail),
			handle: {
				isGoBack: true,
				title: '락앤런 프로그램 관리',
				subTitle: '프로그램 > 프로그램 관리 > 프로그램 상세 정보'
			}
		},
		// 세션 관리
		{
			path: paths.program.session.list,
			element: withSuspense(SessionList),
			handle: {
				title: '락앤런 프로그램 회차 관리',
				subTitle: '락앤런 정기 프로그램 회차 관리'
			}
		},
		{
			path: paths.program.session.detail,
			element: withSuspense(SessionDetail),
			handle: {
				isGoBack: true,
				title: '락앤런 프로그램 상세정보',
				subTitle: '프로그램 > 신청자관리 > 상세정보'
			}
		},
	]
}
